import React from 'react';
import { Link } from 'gatsby';

// Hooks & Querys
import { useSanityPath } from '../../hooks';

import { SvgIcon } from '../media/svgIcon';
import ArrowIcon from '../../svg/arrow.svg';

export const PageLink = ({ page, linkText, ...rest }) => {
  const path = useSanityPath(page);
  return (
    <Link to={path} {...rest}>
      {linkText}
    </Link>
  );
};

export const PathLink = ({ path, linkText, ...rest }) => {
  return (
    <Link to={`/${path}`} {...rest}>
      {linkText}
    </Link>
  );
};

export const SocialLink = ({ link, icon, ...rest }) => {
  return (
    <a href={link} {...rest}>
      <SvgIcon icon={icon} />
    </a>
  );
};

export const ArrowLinkButton = ({ page, linkText, className, arrowColor }) => {
  const path = useSanityPath(page);
  return (
    <Link
      to={path}
      className={`flex items-center font-display text-xl transition-all ${className} hover:text-marphonaGold group`}
    >
      {linkText}
      <ArrowIcon className={`w-16 ${arrowColor && arrowColor} fill-current ml-4`} />
    </Link>
  );
};
export const ArrowLinkExternal = ({ link, linkText, className, arrowColor }) => {
  return (
    <a
      href={link}
      className={`flex items-center font-display text-xl transition-all ${className} hover:text-marphonaGold group`}
    >
      {linkText}
      <ArrowIcon className={`w-16 ${arrowColor && arrowColor} fill-current ml-4`} />
    </a>
  );
};
export const ArrowButton = ({ children, className, arrowColor, ...rest }) => {
  return (
    <button
      className={`flex items-center font-display text-xl transition-colors ${className}`}
      {...rest}
      style={{ textDecoration: 'none' }}
    >
      {children}
      <ArrowIcon className={`w-16 ${arrowColor && arrowColor} fill-current ml-4`} />
    </button>
  );
};
